export default __webpack_public_path__ + "static/SectionBanner_bg-a291e550b67dd5cefb79c7c3c0d266f3.png";